export interface IReferencesByEntity<R = string, K = string> {
  referenceByEntityId: string;
  entity: string;
  reference: R;
  description: string;
  applicationKey: K;
  isActive?: boolean;
  sortOrder: number;
}

export interface IInformationNeeded extends IReferencesByEntity {
  comment?: string;
}

export interface IReferencesByProduct<R = string, K = string> {
  authorizationReferenceByProductId: string;
  reference: R;
  description: K;
  sortOrder: number;
  entity: string;
  children: unknown[];
  isActive?: boolean;
}

export enum ReferenceType {
  AdditionalInformationNeeded = 'AdditionalInformationNeeded',
  AddressLocationType = 'AddressLocationType',
  AddressType = 'AddressType',
  AgreementAccepted = 'AgreementAccepted',
  AuthorizationCase = 'AuthorizationCase',
  Delivery = 'Delivery',
  Level = 'Level',
  MedicalNecessityCriteria = 'MedicalNecessityCriteria',
  PostDecisionSupport = 'PostDecisionSupport',
  ProductLine = 'ProductLine',
  ReferralSource = 'ReferralSource',
  RequestSource = 'RequestSource',
  RequestType = 'RequestType',
  StaffingStatus = 'StaffingStatus',
  Status = 'Status',
  StatusReason = 'StatusReason',
  Type = 'Type',
  Urgency = 'Urgency',
  UrgencyChange = 'UrgencyChange',
  UrgentNotification = 'UrgentNotification',
}

export type ProductLineReferences =
  | 'Status'
  | 'Delivery'
  | 'StatusReason'
  | 'Urgency'
  | 'RequestType';
